import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE } from '@app/constants/Common';
import { requestCandidates } from "@app/services/CandidateService";
import { capitalizeName, stringToOption } from "@app/utils/CommonUtils";
import {
    CddMeCheckStatusOptions,
    GpCddProcessOptions,
    InteractiveChannelOptions,
    ProcessPriorityOptions,
    TodoWCddOptions, UsQualifyCddOptions,
    D2HighlightFields
} from '@pages/dvtjcuv/common/Constant';
import { requestGetDVTJCUVPipeLineList } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import React, { useEffect, useState } from 'react';
import Select from "react-select";

const DVTJCUVPipelineCddFields = [
    {key: 'cdd_id', label: 'Cdd ID', classNames: '', displayType: 'link', inputType: 'number', editable: false},
    {key: 'cdd_full_name', label: 'Họ và tên', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true},
    {key: 'cdd_displayed_company', label: 'Displayed Company', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
    {key: 'cdd_displayed_title', label: 'Displayed Title', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
    {key: 'local_province_email', label: 'Loca tỉnh (email)', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'industry', label: 'Industry', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'function', label: 'Function', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: false, autoAdd: false, searchable: true},
    {key: 'current_find_job_mode', label: 'Chế độ tìm job', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
    {key: 'current_find_job_mode_note_time', label: 'Note time (Chế độ tìm job)', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
];

const DVTJCUVPipelineDetailInfoFields = [
    {key: 'service_use_times', label: 'Lần SD dịch vụ', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: false, autoAdd: false, searchable: true},
    {key: 'cdd_receiver_me_check_status', label: 'Trạng thái check ME của Cdd Receiver', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: CddMeCheckStatusOptions, color: ''},
    {key: 'interactive_channel', label: 'Loại tương tác', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: InteractiveChannelOptions, color: ''},
    {key: 'gp_cdd_process', label: 'GP-Cdd Process (DVTJCUV)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: GpCddProcessOptions, color: ''},
    {key: 'us_qualify_cdd', label: 'Us qualify Cdd (DVTJCUV)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: UsQualifyCddOptions},
    {key: 'to_do_w_cdd', label: 'To do w Cdd (DVTJCUV)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: TodoWCddOptions, color: ''},
    {key: 'current_fu_strategy_date_time', label: 'FU Strategy (This time)', classNames: '', displayType: 'text', inputType: 'text', inputRange: false, editable: true, autoAdd: false, capitalize: false, searchable: true},
    {key: 'current_fu_campaign', label: 'FU Compaign (This time)', classNames: '', displayType: 'text', inputType: 'text', editable: true, autoAdd: false, capitalize: false, searchable: true},
    {key: 'notes', label: 'Notes', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: true},
    {key: 'note_with_cdd', label: 'Note with Cdd', classNames: '', displayType: 'text', inputType: 'text', searchable: true, editable: true},
    {key: 'process_priority', label: 'Ưu tiên xử lý', classNames: '', displayType: 'text', inputType: 'option', options: ProcessPriorityOptions, editable: true},
    {key: 'next_fu_schedule_date_time', label: 'FU Schedule (Next time)', classNames: '', displayType: 'text', inputType: 'date', inputRange: true, editable: true, autoAdd: false, capitalize: false, searchable: true},
    {key: 'next_fu_strategy_date_time', label: 'FU Strategy (Next time)', classNames: '', displayType: 'text', inputType: 'date', inputRange: false, editable: true, autoAdd: false, capitalize: false, searchable: true},
    {key: 'next_fu_campaign', label: 'FU Compaign (Next time)', classNames: '', displayType: 'text', inputType: 'text', editable: true, autoAdd: false, capitalize: false, searchable: true},
    {key: 'note_discussion_w_cdd', label: 'Note Discussion w Cdd', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, autoAdd: false, capitalize: false},
];

const setFieldColorClass = (column) => {
    if (D2HighlightFields.includes(column.key)) {
        return 'text-danger';
    }
    return '';
}

const getProcessPriorityOption = (processPriority) => {
    if (processPriority) {
        return ProcessPriorityOptions.find(option => option.value.toString() === processPriority.toString())
    }
    return {label: "", value: ""}
}

const InputDiscussionWCddAcquireContent = (props) => {
    const [pipeline, setPipeline] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {pipeLineInfo, mode, onChangeInputItem} = props

    const setPipelineInfoForDisplay = (inputPipeline) => {
        const pp = {...inputPipeline}
        pp.local_province_email = stringToOption(pp.local_province_email, true)
        pp.industry = stringToOption(pp.industry, true)
        pp.function = stringToOption(pp.function, true)
        setPipeline({...pp})
    }

    const fetchLatestPipeLines = async (canId) => {
        const params = {
            search_conditions: {
                cdd_id: canId
            },
            sort_columns: {
                created_date_time: ODER_BY_TYPE.DESC
            }
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resPipelines = res.content.pipelines
        if (resPipelines && resPipelines.length > 0) {
            // const firstValidItem = resPipelines.find(item => !!item.cdd_receiver_id);
            const firstValidItem = resPipelines[0];
            if (firstValidItem) {
                DVTJCUVPipelineDetailInfoFields.forEach((item) => {
                    if (item.inputType === 'option') {
                        if (item.key === 'process_priority') {
                            pipeline[item.key] = getProcessPriorityOption(firstValidItem[item.key]);
                        } else {
                            pipeline[item.key] = stringToOption(firstValidItem[item.key], item.isMulti);
                        }
                    } else {
                        pipeline[item.key] = firstValidItem[item.key];
                    }
                })

                setPipelineInfoForDisplay(pipeline)
            }
        }
    }

    const fetchCddDetail = async (canId) => {
        const params = {
            search_conditions: {
                candidate_id: canId
            }
        };

        const res = await requestCandidates(params);
        const candidates = res.content?.candidates;
        if (candidates && candidates.length > 0) {
            const can = candidates[0]
            pipeline.cdd_id = canId
            if (can.personal) {
                pipeline.cdd_full_name = capitalizeName(can.personal.full_name)
            }
            if (can.general) {
                pipeline.cdd_displayed_company = can.general.displayed_company
                pipeline.cdd_displayed_title = can.general.displayed_title
            }

            if (can.job_seeking) {
                if (can.job_seeking.current_find_job_mode === 1) {
                    pipeline.current_find_job_mode = 'On'
                }
                else if (can.job_seeking.current_find_job_mode === 2) {
                    pipeline.current_find_job_mode = 'Off'
                }

                pipeline.current_find_job_mode_note_time= can.job_seeking.note_time
            }

            setPipeline({...pipeline})
        }
    };

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }

    }, [])

    useEffect(() => {
        // if (pipeLineInfo) {
        //     setPipelineInfoForDisplay(pipeLineInfo)
        // } else {
        //     setPipeline({})
        // }
        if (pipeLineInfo.cdd_id) {
            fetchCddDetail(pipeLineInfo.cdd_id)
            fetchLatestPipeLines(pipeLineInfo.cdd_id)
        }
    }, [pipeLineInfo]);

    const onChangeInput = (values, column) => {
        pipeline[column.key] = values
        setPipeline({...pipeline})
        if (onChangeInputItem) {
            onChangeInputItem(values, column)
        }
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    const disableInputPipelineDetail = () => {
        return (!pipeline.cdd_id && !pipeline.cdd_receiver_id)
    }

    const onBlurInput = async (event) => {
        const fieldName = event.target.name
        if (fieldName === 'cdd_id') {
            await fetchCddDetail(event.target.value)
        }
    }

    const disableCddFields = (column) => {
        return !column.editable || (column.key === 'cdd_id' && pipeLineInfo.cdd_id);
    }

    return (
        <div className={'row'}>
            <div className={'col-sm-4'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Cdd</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineCddFields.map(column => {
                            return <div className='col-sm-12' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           disabled={disableCddFields(column)}
                                           onBlur={onBlurInput}
                                           value={getItemValues(column, pipeline[column.key])}
                                           name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>

            <div className={'col-sm-8'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Pipeline</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineDetailInfoFields.map(column => {
                            if (column.inputType === 'option') {
                                return <div className='col-sm-6' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                    <div className='form-group'>
                                        <div style={{width: '100%'}}>
                                            <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                            <Select options={column.options}
                                                    value={getItemValues(column, pipeline[column.key])}
                                                    isDisabled={(!column.editable || disableInputPipelineDetail())}
                                                    name={column.key}
                                                    isMulti={!!column.isMulti}
                                                    onChange={value => {
                                                        onChangeInput(value, column);
                                                    }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            return <div className='col-sm-6' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           disabled={(!column.editable || disableInputPipelineDetail())}
                                           value={getItemValues(column, pipeline[column.key])}
                                           name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InputDiscussionWCddAcquireContent;
